import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import { useState, useEffect } from "react";
import { Input } from "@material-ui/core";
import { getGeoLocation, } from "../../Services/API";
import { getLocationInfoByAddress } from "../../Services/location_API";
import axios from "axios";
const GeoLocation = () => {
    const gMapKey = process.env.REACT_APP_GMAP_KEY;
    const [center, setCenter] = useState({ lat: 34.0549076, lng: -118.242643 });
    const [address, setAddress] = useState("");
    const [searchAddress, setSearchAddress] = useState("");
    const [restAddress, setRestAddress] = useState(true);
    const containerStyle = {
        width: "100%",
        height: "250px"
    };
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: gMapKey || "",
        libraries: ["places"]
    });
    const handleClick = async (e: any) => {
        const lat = e.latLng.lat();
        const lng = e.latLng.lng();
        console.log("lat", lat);
        console.log("lng", lng);
        const locationRes = await getGeoLocation(lat, lng);
        const locData = locationRes?.data?.[0];
        console.log("locDAta address", locData?.formattedAddress);
        setAddress(locData?.formattedAddress);
    };

    useEffect(() => {
        if (!isLoaded) return;

        const load = async () => {
            try {
                const countryURL = process.env.REACT_APP_COUNTRY_URL;
                let countryRes = await axios.get(countryURL as any);
                // geoip(...) → JSON
                const jsonStr = countryRes?.data?.replace(/^geoip\(/, '').replace(/\)$/, '');
                const geoData = JSON.parse(jsonStr)

                if (geoData?.city) {
                    const locationInfo = await getLocationInfoByAddress(geoData?.city);
                    setCenter({
                        lat: locationInfo[0]?.latitude,
                        lng: locationInfo[0]?.longitude
                    });
                }
            } catch (error) {
                console.error("Error fetching geolocation:", error);
            }
        };
        load();
    }, [isLoaded, restAddress]);


    useEffect(() => {
        if (!searchAddress) {
            setRestAddress(!restAddress);
            return;
        }
        const delayDebounce = setTimeout(async () => {
            const locationInfo = await getLocationInfoByAddress(searchAddress);

            setCenter({
                lat: locationInfo?.[0]?.latitude,
                lng: locationInfo?.[0]?.longitude
            });
        }, 600);

        return () => clearTimeout(delayDebounce);

    }, [searchAddress]);
    if (!isLoaded) return null;

    return (
        <div>
            <Input
                type="text"
                placeholder="search address"
                value={searchAddress}
                onChange={(e) => setSearchAddress(e.target.value)}
                style={{ width: "100%", padding: "8px", boxSizing: "border-box", margin: "10px 0", color: "#fff" }}
            />
            <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}

                zoom={15}
                onClick={(e) => {
                    handleClick(e);
                }}
            >
            </GoogleMap>
            <div style={{ marginTop: "10px" }}>
                <div>
                    <strong>Selected Location:</strong>
                </div>
                <div>
                    {address || "Click on the map to select a location"}
                </div>
                <div style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>


                </div>
            </div>
        </div>
    );
};

export default GeoLocation;
